import {InjectionToken} from '@angular/core';

export type HeroApplication = {
  alias: string,
  name: string,
  path: string,
  route: string[],
  default?: boolean,
  icon?: string,
  menu?: string,
};

export const HERO_APPLICATIONS = new InjectionToken<HeroApplication[]>('HERO applications');

export const HERO_APPLICATION_PREFIX = new InjectionToken<string>('HERO application prefix', {
  providedIn: 'root',
  factory: () => 'HERO'
});
